import { Input as AntInput, InputProps, InputRef } from 'antd';
import * as React from 'react';
import {
  InputGroupWrapper,
  InputSearchWrapper,
  InputSimpleWrapper,
  InputWrapper,
  TextAreaSimpleWrapper,
  TextAreaWrapper,
} from './styles/input.style';

const { Search, TextArea: Textarea, Group } = AntInput;

const StyledInput = InputWrapper(AntInput);
const InputGroup = InputGroupWrapper(Group);
const InputSearch = InputSearchWrapper(Search);
const TextArea = TextAreaWrapper(Textarea);
const InputSimple = InputSimpleWrapper(AntInput);
const TextAreaSimple = TextAreaSimpleWrapper(Textarea);

const Input = React.forwardRef<InputRef, InputProps>((props, ref) => {
  return <StyledInput {...props} ref={ref} />;
});

Input.displayName = 'Input';

export default Input;
export { InputGroup, InputSearch, InputSimple, TextArea, TextAreaSimple };
